import { ButtonContainer, IDataTableColumn } from "nsitools-react";
import * as React from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";

import { HealthPackApi, HealthPackGridDto, HealthPackSearch } from "../../../../api";
import { ERoutes } from "../../../../ERoutes";
import { EditButton, SearchTablePage, ViewButton } from "../../../../components";
import { useGlobalData } from "../../../../contexts";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";

export interface IHealthPackListPageProps {}

export const HealthPackListPage: React.FunctionComponent<IHealthPackListPageProps> = (props) => {
  const api = useApiService(HealthPackApi);
  const { t } = useTl();
  const history = useHistory();
  const { currentLanguage } = useGlobalData();

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: HealthPackGridDto) => (
          <ButtonContainer>
            <ViewButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.healthPack}/${row.healthPackId}/detail/view`)}
            />
            <EditButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.healthPack}/${row.healthPackId}/detail/edit`)}
            />
          </ButtonContainer>
        ),
      },
      {
        header: () => t(ETLCodes.Code),
        fieldName: "healthPackCode",
      },
      {
        header: () => t(ETLCodes.HealthPackGroup),
        fieldName: "healthPackGroupName",
      },
      {
        header: () => t(ETLCodes.Article),
        fieldName: "articleName",
        render: (row: HealthPackGridDto) => (
          <Link to={`${ERoutes.article}/${row.articleId}/detail/view`} target="_blank">
            {row.articleName}
          </Link>
        ),
      },
      {
        header: () => t(ETLCodes.Laboratory),
        fieldName: "lab",
      },
    ],
    [history, t]
  );

  const addItemFunction = React.useCallback(() => {
    history.push(`${ERoutes.healthPack}/0/detail/edit`);
  }, [history]);

  const searchHealthPackFunction = React.useCallback(
    (sObj) => api.baseSearch(HealthPackSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId })),
    [api, currentLanguage.languageId]
  );
  const exportHealthPackFunction = React.useCallback(
    (sObj) => api.exportXlsFile(HealthPackSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId })),
    [api, currentLanguage.languageId]
  );

  const searchHealthPackCriteriaFunction = React.useCallback(() => api.getSearchCriterias(true), [api]);

  return (
    <SearchTablePage
      columns={columns}
      getCriteriasFunction={searchHealthPackCriteriaFunction}
      searchFunction={searchHealthPackFunction}
      exportFunction={exportHealthPackFunction}
      addFunc={addItemFunction}
      sortKeys={{ healthPackCode: "ASC" }}
      breadCrumbs={[{ text: t(ETLCodes.Packs) }]}
    />
  );
};
